export default __webpack_public_path__ + "static/media/centro-resoluca-cardiologia-mobile.f994940d.jpg";